import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'

const service = new ApolloClientService()

export default class Exercises {
  getAllExercises = (customerid) => {
    return new Promise((resolve, reject) => {
      service
        .getAllExercises(customerid)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getRangeExercises = (patientid, startdate, enddate) => {
    return new Promise((resolve, reject) => {
      service
        .getRangeExercises(patientid, startdate, enddate)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
}
